let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kPeYw")).then(() => parcelRequire('deSfB'));